







 function SingleProductPage(){

    return (
        <div>

        </div>
    )
 };

 export default SingleProductPage;